import { render } from "./DigitalIdCardForm.vue?vue&type=template&id=aa84fe30"
import script from "./DigitalIdCardForm.vue?vue&type=script&lang=js"
export * from "./DigitalIdCardForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__